// React and Router
import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'

// Form and Validation
import { Field, FormikProvider, useFormik } from 'formik'
import * as Yup from 'yup'

// Components
import Input from '../../../components/common/CustomInput'

// Utils
import { setToken } from '../../../utils/cookies/cookies'
import useUserStore from '../../../utils/state/useUserStore'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email format')
    .required('Email is required'),
  password: Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required'),
})

const Login = () => {
  const setUser = useUserStore((state) => state.setUser)
  const navigate = useNavigate()
  const [error, setError] = useState('')

  const handleSubmit = async (values) => {
    try {
      const { data } = await axiosAuthInstance.post('/auth/login', values)
      setToken(data?.token)
      setUser(data?.metadata)
      if (data?.token) {
        navigate('/')
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setError(error.response.data.message)
      } else {
        setError('An unexpected error occurred. Please try again.')
      }
    }
  }

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema,
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
  })

  return (
    <div className='flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8'>
      <div className='sm:mx-auto sm:w-full sm:max-w-sm'>
        <h2 className='mt-10 text-center text-2xl font-bold leading-9 tracking-tight '>
          Login
        </h2>
      </div>
      <div className='sm:mx-auto sm:w-full sm:max-w-sm mt-10'>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <div className='flex flex-col gap-6'>
              <Field
                name='email'
                type='email'
                label='Email'
                placeholder='Email'
                component={Input}
              />
              <Field
                name='password'
                type='password'
                label='Password'
                placeholder='Password'
                component={Input}
              />
            </div>

            {error && (
              <div className='text-red-700 text-sm sm:text-base font-normal mt-6 break-words'>
                {error}
              </div>
            )}

            <div className='mt-8'>
              <button
                type='submit'
                disabled={formik.isSubmitting}
                className='w-full py-3 rounded-md !text-prime bg-white border border-prime hover:bg-prime hover:!text-white transition-all duration-300 disabled:bg-prime disabled:pointer-events-none disabled:cursor-auto disabled:bg-opacity-80'
              >
                Sign in
              </button>
            </div>
            {/* <div className='text-sm mt-5'>
              <NavLink
                to='/forget-password'
                className='font-semibold text-[#EF4044] hover:text-[#EF4044]'
              >
                Forgot password?
              </NavLink>
            </div> */}
          </form>
        </FormikProvider>
      </div>
    </div>
  )
}

export default Login
